import React, { useState, useRef } from 'react'
import { Form, Row } from 'react-bootstrap';
import LocationSearchInput from '../../components/LocationSearchInput';
import SearchFormFilters from './SearchFormFilters';

const SearchForm = ({ request, options }) => {
  const {
    location,
    distance,
    start_date,
    end_date,
    show_bookable_now_only,
    show_reservable_only,
    show_deliverable_only,
    filters,
    for_sales
  } = request;

  const [startDate, setStartDate] = useState(start_date);
  const [endDate, setEndDate] = useState(end_date);
  const [loc, setLocation] = useState(location || '');
  const submitRef = useRef();

  return (
    <Form action={`/rv-${for_sales ? 'sales' : 'rentals'}/search`} acceptCharset="UTF-8" method="get" style={{margin: "auto"}}>
      <input name="utf8" type="hidden" value="✓"></input>
      <Row className="search-form row-centered" style={{ marginTop: "0px", gap: "4px", whiteSpace: "nowrap"}}>
        <Form.Group controlId="autocompleteloc" className="col-size col-centered">
          <LocationSearchInput location={loc} setLocation={setLocation} />
        </Form.Group>
        {!for_sales && <>
          <Form.Group controlId="start_date" className="col-size col-centered">
            <Form.Control
              type="date"
              name="start_date"
              defaultValue={startDate}
              placeholder="Start Date"
              onChange={(e) => setStartDate(e.target.value)} />
          </Form.Group>
          <Form.Group controlId="end_date" className="col-size col-centered">
            <Form.Control
              type="date"
              name="end_date"
              defaultValue={endDate}
              placeholder="End Date"
              onChange={(e) => setEndDate(e.target.value)} />
          </Form.Group>
        </>}
        <div className="col-size col-centered">
          <Form.Control
            className="btn btn-green btn-sm pad_small search-btn center-block"
            type="submit"
            name="commit"
            ref={submitRef}
            value="Search RVs"
          />
        </div>
      </Row>

      <SearchFormFilters request={request} options={options} submitRef={submitRef} />
    </Form>
  )
}

export default SearchForm;